import React from 'react';
import {Dropdown, Flex} from '@priority-software/priority-style-react';
import {Label} from '../../../components/Common/Label';
import {getMessageText} from '../utils/getMessageText';
import styles from '../styles/QuickSearch.module.scss';

export const ResultsStatus = ({isSearching, queryLength, numFound}) => {
    const message = getMessageText(queryLength, isSearching, numFound);
    if (message) {
        return (
            <Dropdown.Item disabled>
                <Flex>
                    <Label
                        textColor="secondary-400"
                        skin="paragraph-2"
                        componentClasses={styles.messageLabel}
                    >
                        {message}
                    </Label>
                </Flex>
            </Dropdown.Item>
        );
    } else {
        return null;
    }
};
